export default __webpack_public_path__ + "static/subway-2e9bf3244af1911f0a8fcb7a78936615.png";